import { useState, useEffect } from 'react';

const useNewsletterModal = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [hasShown, setHasShown] = useState(false);

    useEffect(() => {
        // Check if modal has been shown before (localStorage)
        const modalShown = localStorage.getItem('newsletter-modal-shown');
        if (modalShown) {
            setHasShown(true);
            return;
        }

        // Auto-show modal after 30 seconds if not shown before
        const timer = setTimeout(() => {
            if (!hasShown) {
                setIsModalOpen(true);
                setHasShown(true);
                localStorage.setItem('newsletter-modal-shown', 'true');
            }
        }, 30000); // 30 seconds

        // Show modal on scroll (when user scrolls 50% of page)
        const handleScroll = () => {
            if (hasShown) return;

            const scrolled = window.scrollY;
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;
            const scrollPercentage = scrolled / (documentHeight - windowHeight);

            if (scrollPercentage > 0.5) {
                setIsModalOpen(true);
                setHasShown(true);
                localStorage.setItem('newsletter-modal-shown', 'true');
                window.removeEventListener('scroll', handleScroll);
            }
        };

        // Show modal on exit intent (mouse moves to top of page)
        const handleMouseLeave = (e) => {
            if (hasShown) return;

            if (e.clientY <= 0) {
                setIsModalOpen(true);
                setHasShown(true);
                localStorage.setItem('newsletter-modal-shown', 'true');
                document.removeEventListener('mouseleave', handleMouseLeave);
            }
        };

        window.addEventListener('scroll', handleScroll);
        document.addEventListener('mouseleave', handleMouseLeave);

        return () => {
            clearTimeout(timer);
            window.removeEventListener('scroll', handleScroll);
            document.removeEventListener('mouseleave', handleMouseLeave);
        };
    }, [hasShown]);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    // Function to reset modal shown status (for testing or admin purposes)
    const resetModalStatus = () => {
        localStorage.removeItem('newsletter-modal-shown');
        setHasShown(false);
    };

    return {
        isModalOpen,
        openModal,
        closeModal,
        resetModalStatus
    };
};

export default useNewsletterModal; 